<template>
	<div class="empty-wrapper">
		<div class="empty-content">
			<img src="@/assets/noInfo.png" :alt="emptyText" />
			<p>{{ emptyText }}</p>
		</div>
	</div>
</template>

<script>
	// 数据为空展示组件
	export default {
		name: 'EmptyContent',
		components: {},
		props: {
			emptyText: {
				type: String,
				default: '暂无数据'
			}
		},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
